export default __webpack_public_path__ + "static/media/MDI - facebook.80d17278.svg";